import { reactive, ref } from "vue";
import {
  saveQaStepRedesignContent,
  getQaStepRedesignContent,
  getQaStepInfoContent,
} from "@/utils/localStorageUtils";

export const QA_REDESIGN_PRESERVE_STEP1_FROM = new Set([
  "QrCode",
  "QaFormStepTwo",
  "QaFormStepTwoRedesign",
  "QaFormStepThree",
  "QaFormStepThreeRedesign",
]);

export function shouldPreserveQaRedesignSession(fromRouteName) {
  return QA_REDESIGN_PRESERVE_STEP1_FROM.has(fromRouteName);
}

export function getQaRedesignStepTwoRoute(currentRouteName) {
  return currentRouteName === "QaForm" ? "QaFormStepTwo" : "QaFormStepTwoRedesign";
}

export function getQaRedesignStepThreeRoute(currentRouteName) {
  return currentRouteName === "QaFormStepTwo"
    ? "QaFormStepThree"
    : "QaFormStepThreeRedesign";
}

export function createEmptyRedesignDraft() {
  return {
    step2: {
      allviewSnapshot: null,
      phoneNumber: "",
      selectedPhoneAreaCode: "",
      carUserName: "",
      code: "",
      doDate: "",
      currentSwipeIndex: 0,
    },
    step3: {
      imgUploadSnapshot: null,
      currentSwipeIndex: 0,
    },
    lastStep: 1,
  };
}

export function ensureRedesignDraft(qastepinfo) {
  if (!qastepinfo.redesignDraft) {
    qastepinfo.redesignDraft = createEmptyRedesignDraft();
  }
  return qastepinfo;
}

export const clearQaStepRedesignInfo = () => {
  saveQaStepRedesignContent("");
};

function createEmptyQaStepInfo() {
  return {
    carInfo: {},
    productInfo: [],
    doInfo: {
      doDate: "",
      doCarPart: [],
      doCarShop: "",
      doCarShopId: "",
      doPrice: "",
    },
    ownerinfo: {
      phoneNumber: "",
      smsVerificationCode: "",
      fullName: "",
    },
    qaInfo: {
      content: "水斑、发污、水解、黄变",
    },
    imgInfo: [],
    redesignDraft: createEmptyRedesignDraft(),
  };
}

export const useQaFormRedesignEffect = () => {
  let qastepinfo = getQaStepRedesignContent();
  if (!qastepinfo) {
    const legacy = getQaStepInfoContent();
    if (legacy?.productInfo?.length) {
      qastepinfo = legacy;
      saveQaStepRedesignContent(qastepinfo);
    } else {
      qastepinfo = createEmptyQaStepInfo();
    }
  }
  ensureRedesignDraft(qastepinfo);

  const qaObj = reactive(qastepinfo);
  const isCanClickCheckbox = ref(false);

  const saveQaStepInfo = () => {
    saveQaStepRedesignContent(qastepinfo);
  };

  const saveQaStepInfoCache = () => {
    saveQaStepRedesignContent(qastepinfo);
  };

  const getNewData = () => getQaStepRedesignContent();

  const deleteQaProductInfo = (index) => {
    qaObj.productInfo.splice(index, 1);
    saveQaStepInfo();
  };

  return {
    qaObj,
    isCanClickCheckbox,
    saveQaStepInfo,
    saveQaStepInfoCache,
    deleteQaProductInfo,
    getNewData,
  };
};
